import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-generic-loading',
  templateUrl: './generic-loading.component.html',
  styleUrls: ['./generic-loading.component.scss']
})
export class GenericLoadingComponent {
  @Input() isLoading = false;
  @Input() top: number;
  @Input() left: number;
  @Input() right: number;
  @Input() bottom: number;
  @Input() size: number = 24;
  constructor() {}
}
